import { render, staticRenderFns } from "./SyncForm.vue?vue&type=template&id=5f7f7960&scoped=true&"
import script from "./SyncForm.vue?vue&type=script&lang=js&"
export * from "./SyncForm.vue?vue&type=script&lang=js&"
import style0 from "./SyncForm.vue?vue&type=style&index=0&id=5f7f7960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f7960",
  null
  
)

export default component.exports